export * from './services/player.service';
export * from './play-button/play-button.component';
export * from './player.component';
export * from './seek-track/seek-track.component';
export * from './pause-button/pause-button.component';
export * from './stop-button/stop-button.component';
export * from './next-track/next-track.component';
export * from './previous-track/previous-track.component';
export * from './mute-track/mute-track.component';
export * from './repeat-track/repeat-track.component';
export * from './music-volume/music-volume.component';
export * from './clear-playlist/clear-playlist.component';
export * from './view-queue/view-queue.component';
export * from './song-info/song-info.component';
export {GenericAvatarFullImageComponent} from './song-info/song-info.component';
export * from './song-info/song-info-avatar/song-info-avatar.component';
export * from './song-info/song-info-details/song-info-details.component';



// WEBPACK FOOTER //
// ./src/app/player/index.ts